import { ElementRef, Type } from "@angular/core";
import { PersonsOrganisationDto } from "@flyfreely-portal-ui/flyfreely";

export interface AvailableWidgets {
    [widgetIdentifier: string]: boolean;
}

export interface WidgetRegistration {
    widgetIdentifier: string;
    component: Type<any>;
    isAvailable: isAvailableFn;
    isAvailableForUser?: isAvailableForUserFn;
}

export interface WidgetStatus {
    [widgetIdentifier: string]: {
        available: boolean;
        selected: boolean;
    };
}

export type SelectedWidgets = { [widgetId: string]: boolean };

export type isAvailableFn = (organisation: PersonsOrganisationDto) => boolean;

export type isAvailableForUserFn = (
    organisation: PersonsOrganisationDto
) => boolean;

/**
 * A container for the available widgets.
 */
export class RegisteredWidgets {
    constructor(public registeredWidgets: WidgetRegistration[]) {}
}

export abstract class WidgetManager {
    abstract registerWidget(widgetId: string, element: ElementRef): void;
    abstract unregisterWidget(widgetId: string): void;
}